/**
 * Hero background crossfade.
 *
 * The slides are stacked and faded purely in CSS — this only moves the
 * `is-active` class along on a timer. No horizontal movement, so it reads as a
 * smooth background dissolve behind the copy.
 *
 * Respects prefers-reduced-motion (holds on the first slide) and pauses while
 * the tab is hidden so it isn't burning cycles in the background.
 */
window.Blockline = window.Blockline || {};

window.Blockline.hero = ( function () {
	'use strict';

	/**
	 * Wire up one hero.
	 *
	 * @param {HTMLElement} root The .bl-hero section.
	 */
	function setup( root ) {
		var group = root.querySelector( '.bl-hero__slides' );
		var slides = group ? Array.prototype.slice.call( group.querySelectorAll( '.bl-hero__slide' ) ) : [];

		// One slide (or none) has nothing to cycle.
		if ( slides.length < 2 ) {
			return;
		}

		if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
			return;
		}

		var interval = parseInt( root.dataset.interval, 10 ) || 6000;
		var current = 0;
		var timer = null;

		function show( next ) {
			slides[ current ].classList.remove( 'is-active' );
			current = ( next + slides.length ) % slides.length;
			slides[ current ].classList.add( 'is-active' );
		}

		function advance() {
			show( current + 1 );
		}

		function start() {
			if ( timer ) {
				return;
			}
			timer = window.setInterval( advance, interval );
		}

		function stop() {
			if ( timer ) {
				window.clearInterval( timer );
				timer = null;
			}
		}

		// Pause when the tab isn't visible.
		document.addEventListener( 'visibilitychange', function () {
			if ( document.hidden ) {
				stop();
			} else {
				start();
			}
		} );

		start();
	}

	function init() {
		document.querySelectorAll( '.bl-hero' ).forEach( setup );
	}

	return { init: init };
} )();
